import { api } from '@marketplace-web/core-api/core-api-client-util'

import {
  GetItemUploadFeedbackRatingsResp,
  SendItemUploadFeedbackArgs,
  SendItemUploadFeedbackResp,
  GetShowItemUploadFeedbackResp,
  UploadAnotherItemTipResp,
} from '../types/after-upload-actions'
import { sendItemUploadFeedbackArgsToParams } from '../transformers/after-upload-actions'

export const sendItemUploadFeedback = (args: SendItemUploadFeedbackArgs) =>
  api.put<SendItemUploadFeedbackResp>(
    '/items/upload_feedback',
    sendItemUploadFeedbackArgsToParams(args),
  )

export const getItemUploadFeedbackRatings = () =>
  api.get<GetItemUploadFeedbackRatingsResp>('/items/upload_feedback')

export const getShowItemUploadFeedback = () =>
  api.get<GetShowItemUploadFeedbackResp>('/items/show_upload_feedback')

export const getUploadAnotherItemTip = (itemId: number) =>
  api.get<UploadAnotherItemTipResp>('/item_upload/upload_another_item_tip', {
    params: { item_id: itemId },
  })
